// A compact day-cell summary: the top entry as a coloured, truncated text chip
// + a "+N more" count. Shared by the trainer phone calendar and the client
// portal calendar so both read the same and never overflow (chip truncates,
// never wraps). Provenance colour comes from ENTRY_STYLE.
import { ENTRY_STYLE } from "./sessionStyle";
import type { EntryProvenance } from "./viewModel";
import { cn } from "../lib/cn";

export interface DaySummaryItem {
  provenance: EntryProvenance;
  label: string;
}

export function DaySummary({
  items,
  max = 1,
  moreLabel,
}: {
  items: DaySummaryItem[];
  max?: number;
  moreLabel: (n: number) => string;
}) {
  if (items.length === 0) return null;
  const shown = items.slice(0, max);
  const extra = items.length - shown.length;
  return (
    <span className="mt-auto flex w-full flex-col gap-0.5 pt-0.5">
      {shown.map((it, i) => (
        <span
          key={`${it.provenance}-${i}`}
          className={cn(
            "flex items-center gap-1 truncate rounded px-1 py-0.5 text-left text-[0.62rem] font-bold leading-tight text-white",
            ENTRY_STYLE[it.provenance].grad,
          )}
          title={it.label}
        >
          <span className="truncate">{it.label}</span>
        </span>
      ))}
      {extra > 0 && (
        <span className="pl-0.5 text-[0.6rem] font-bold text-body-soft">
          {moreLabel(extra)}
        </span>
      )}
    </span>
  );
}
